import React from 'react';
import { BookOpen, FileText, Search, Shield, Zap } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: BookOpen,
    title: 'Manual Maestro Guía de Crédito 700+ en PDF',
    desc: 'Tuyo para siempre.'
  }, {
    icon: Zap,
    title: 'Protocolo 72h',
    desc: 'Instrucciones exactas para tu primera ronda de disputas.'
  }, {
    icon: Search,
    title: 'Auditoría Extrema',
    desc: 'Encuentra los errores que el 80% de hispanos tiene sin saberlo.'
  }, {
    icon: FileText,
    title: 'Método de Verificación',
    desc: 'Qué hacer cuando el buró dice que no puede borrar una cuenta.'
  }, {
    icon: Shield,
    title: 'Plan de Blindaje',
    desc: 'Protege tu crédito una vez que esté limpio.'
  }];
  return <section className="bg-navy-900 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-216">
      <div className="mx-auto max-w-5xl" data-id="element-217">
        <div className="mb-16 text-center" data-id="element-218">
          <h2 className="mb-6 text-4xl sm:text-5xl font-bebas text-white" data-id="element-219">
            Lo Que Recibes <span className="text-gold-400" data-id="element-220">Hoy</span>
          </h2>
        </div>

        <div className="grid gap-8 lg:grid-cols-2 lg:items-center" data-id="element-221">
          <div className="order-2 lg:order-1 space-y-6" data-id="element-222">
            {items.map((item, index) => <div key={index} className="flex gap-4 rounded-xl bg-navy-800 p-5 border border-slate-700/50 hover:border-gold-500/30 transition-colors" data-id="element-223">
                <div className="flex-shrink-0 mt-1" data-id="element-224">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gold-500/10" data-id="element-225">
                    <item.icon className="h-5 w-5 text-gold-400" data-id="element-226" />
                  </div>
                </div>
                <div data-id="element-227">
                  <h3 className="text-lg font-bold text-white mb-1" data-id="element-228">
                    {item.title}
                  </h3>
                  <p className="text-slate-400" data-id="element-229">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="order-1 lg:order-2 flex justify-center" data-id="element-230">
            <div className="relative" data-id="element-231">
              <div className="absolute -inset-4 rounded-full bg-gold-500/20 blur-3xl" data-id="element-232"></div>
              <img src="https://cdn.magicpatterns.com/uploads/meMnx1rVy2wfikc36UUxhS/IMAGE-GUIA_DE_CREDITO_7002B_EL_METODO_72H.png" alt="Contenido del producto" className="relative z-10 w-full max-w-sm drop-shadow-2xl" data-id="element-233" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}